$('.marquee_slider').slick({
  dots: false,
  infinite: true,        // infinite loop
  slidesToShow: 3,
  slidesToScroll: 3,     // one slide at a time for smooth continuous
  speed: 20000,           // transition speed, adjust for smoothness
  autoplay: true,
  autoplaySpeed: 0,      // 0 for nonstop motion
  cssEase: 'linear',     // smooth continuous scrolling
  arrows: false,         // hide arrows for marquee effect
  pauseOnHover: false,   // don't stop on hover
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1, // keep it 1 for smooth marquee
        infinite: true,
        speed: 5000,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 5000
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 5000
      }
    }
  ]
});



document.addEventListener("DOMContentLoaded", function () {
  const anchorElement = document.getElementById("s-224e2e1a-a14e-4064-8d3f-a21a9c9c4e82");

  if (anchorElement) {
    anchorElement.addEventListener("click", function (event) {
      event.preventDefault();  // Prevent the default anchor action (navigation)

      // Access the iframe and the button inside it
      const iframe = document.getElementById('launcher');  // Make sure 'launcher' is the correct ID of the iframe
      const iframeDocument = iframe.contentWindow.document;

      // Find the button inside the iframe document
      const button = iframeDocument.querySelector('button[aria-label="Open messaging window"]');

      if (button) {
        button.click();  // Trigger the button click inside the iframe
      } else {
        console.log("Button not found inside iframe!");
      }
    });
  } else {
    console.log("Anchor element not found!");
  }
});




// custom contact form js 

const input = document.getElementById('file-upload');
const uploadText = document.getElementById('upload-text');
const errorMsg = document.getElementById('error-msg');

// Create preview container dynamically
const previewContainer = document.createElement('div');
previewContainer.classList.add('preview-container');
input.closest('.ctm_image_upload').appendChild(previewContainer);

input.addEventListener('change', function () {
  previewContainer.innerHTML = "";

  if (this.files.length > 0) {
    const file = this.files[0];
    uploadText.innerText = file.name;
    errorMsg.style.display = 'none';

    // Image preview
    if (file.type.startsWith('image/')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('image-wrapper');

      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      wrapper.appendChild(img);

      const closeBtn = document.createElement('span');
      closeBtn.innerHTML = '&times;'; // ❌ symbol
      closeBtn.classList.add('close-btn');
      wrapper.appendChild(closeBtn);

      previewContainer.appendChild(wrapper);

      closeBtn.addEventListener('click', function () {
        wrapper.remove();
        input.value = "";
        uploadText.innerText = '⬆ Upload';
      });

    } else {
      // Non-image file
      const fileName = document.createElement('div');
      fileName.classList.add('file-name');
      fileName.innerText = "Selected: " + file.name;
      previewContainer.appendChild(fileName);
    }
  }
});

// Validation
document.querySelector("form").addEventListener("submit", function (e) {
  if (!input.files.length) {
    errorMsg.style.display = 'block';
    e.preventDefault();
  }
});


const checkbox = document.querySelector('input[type="checkbox"][name^="contact"]');
const submitBtn = document.querySelector('.contact-us-btn button');

checkbox.addEventListener('change', () => {
  if (checkbox.checked) {
    // Enable button
    submitBtn.style.opacity = '1';
    submitBtn.style.pointerEvents = 'auto';
  } else {
    // Disable button again
    submitBtn.style.opacity = '0.5';
    submitBtn.style.pointerEvents = 'none';
  }
});